import { Endpoints } from '@xver/apis';
import type { NotificationPreferenceModel } from '@xver/apis/v1/notification-preferences/model';
import { useQuery } from '@tanstack/react-query';

export const NOTIFICATION_PREFERENCES_QUERY_KEY = ['apis.v1.users.me.notification-preferences'];

export function useNotificationPreferencesQuery() {
    return useQuery<NotificationPreferenceModel>({
        queryKey: NOTIFICATION_PREFERENCES_QUERY_KEY,
        queryFn: Endpoints.v1.NotificationPreferences.getNotificationPreferences,
        staleTime: 30_000,
    });
}
